"use strict";
/**
 * @author PKr
 * @author Adam Drda
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueDifference_1 = require("../../core/model/ValueDifference");

var ApprovalReportPMRowDTO_1 = require("../model/ApprovalReportPMRowDTO");

var ApprovalReportPMRowDTOConverter_1 = require("./ApprovalReportPMRowDTOConverter");

var ApprovalReportPMRowDTOConverterImpl =
/*#__PURE__*/
function (_ApprovalReportPMRowD) {
  _inherits(ApprovalReportPMRowDTOConverterImpl, _ApprovalReportPMRowD);

  function ApprovalReportPMRowDTOConverterImpl() {
    _classCallCheck(this, ApprovalReportPMRowDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApprovalReportPMRowDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ApprovalReportPMRowDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var kpis = {};

      if (source.kpiValues) {
        Object.keys(source.kpiValues).forEach(function (key) {
          var valueObj = source.kpiValues[key];

          if (valueObj.value) {
            kpis[key] = conversions.toBigNumber(valueObj.value);
          } else if (valueObj) {
            kpis[key] = conversions.toBigNumber(valueObj);
          }
        });
      }

      return new ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO(ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.id.valueOf(conversions.documentToClassId(source)), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.nodeId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.reportId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.level.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.path.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.isGroup.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.entity.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.entityId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.title.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promotionExtId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promotionTypeId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promoTypeName.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promotionDiscount.valueOf(source.promotionDiscount ? conversions.toBigNumber(source.promotionDiscount) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.storeSpecification.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promoWFState.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.cd.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.cm.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.windowTypeId.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.windowTypeName.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.windowName.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.windowWFState.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.startDate.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.daysValid.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.workflowNote.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.windowCount.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.skuCount.valueOfField(source), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.sales.valueOf(source.sales ? conversions.asObject(source, 'sales', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.promoVolume.valueOf(source.promoVolume ? conversions.asObject(source, 'promoVolume', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.gm.valueOf(source.gm ? conversions.asObject(source, 'gm', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.gmPercentage.valueOf(source.gmPercentage ? conversions.asObject(source, 'gmPercentage', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.proxyBm2.valueOf(source.proxyBm2 ? conversions.asObject(source, 'proxyBm2', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.proxyBm2Percentage.valueOf(source.proxyBm2Percentage ? conversions.asObject(source, 'proxyBm2Percentage', ValueDifference_1.deserializeValueDifferenceBigNumber(conversions)) : null), ApprovalReportPMRowDTO_1.ApprovalReportPMRowDTO.schema.snapshotMissing.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        nodeId: source.nodeId,
        reportId: source.reportId,
        level: source.level,
        path: source.path,
        isGroup: source.isGroup,
        entity: source.entity,
        entityId: source.entityId,
        title: source.title,
        promotionExtId: source.promotionExtId,
        promotionTypeId: source.promotionTypeId,
        promoTypeName: source.promoTypeName,
        promotionDiscount: source.promotionDiscount ? conversions.fromBigNumber(source.promotionDiscount) : null,
        storeSpecification: source.storeSpecification,
        promoWFState: source.promoWFState,
        cd: source.cd,
        cm: source.cm,
        windowTypeId: source.windowTypeId,
        windowTypeName: source.windowTypeName,
        windowName: source.windowName,
        windowWFState: source.windowWFState,
        startDate: source.startDate ? conversions.fromDate(source.startDate) : null,
        daysValid: source.daysValid,
        workflowNote: source.workflowNote,
        windowCount: source.windowCount,
        skuCount: source.skuCount,
        sales: source.sales ? conversions.asObject(source, 'sales', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        promoVolume: source.promoVolume ? conversions.asObject(source, 'promoVolume', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        gm: source.gm ? conversions.asObject(source, 'gm', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        gmPercentage: source.gmPercentage ? conversions.asObject(source, 'gmPercentage', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        proxyBm2: source.proxyBm2 ? conversions.asObject(source, 'proxyBm2', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        proxyBm2Percentage: source.proxyBm2Percentage ? conversions.asObject(source, 'proxyBm2Percentage', ValueDifference_1.serializeValueDifferenceBigNumber(conversions)) : null,
        snapshotMissing: source.snapshotMissing
      });
      return result;
    }
  }]);

  return ApprovalReportPMRowDTOConverterImpl;
}(ApprovalReportPMRowDTOConverter_1.ApprovalReportPMRowDTOConverter);

exports.ApprovalReportPMRowDTOConverterImpl = ApprovalReportPMRowDTOConverterImpl;